<template>
    <div>
        <header-portrate />


    <div style="margin-bottom:70px;">
        <bread-crumbs :items="items"></bread-crumbs>
        <tabs-comp :tabs="tabs" />

        <v-row class="mainrow m-2" :style="`background:#d7b10015;direction:`+lang.dir+`;margin-top:100px !important;border:1px solid #555;border-radius:10px`">
            <v-col cols="12" md="12" sm="12" class="text-center backRed">
                {{ display_message }}
            </v-col>
            <v-col cols="12" md="12" sm="12" class="text-center">
                <v-row>

                    <v-col cols="12" md="2"></v-col>
                    <v-col cols="12" md="8">
                        <v-row>
                            <v-col cols="12" md="2" sm="12">{{ lang.integration_type}}</v-col>
                            <v-col cols="12" md="2" sm="12"><b-form-select class="selborder" :options="zatca_type" v-model="zatca.zatca_type" /></v-col>

                            <v-col cols="12" md="2" sm="12">{{ lang.active_zatca}}</v-col>
                            <v-col cols="12" md="2" sm="12"><b-form-select class="selborder" :options="active_zatca" v-model="zatca.active_zatca" /></v-col>

                            <v-col cols="12" md="2" sm="12">{{ lang.otp_number}}</v-col>
                            <v-col cols="12" md="2" sm="12"><b-form-input class="inborder" v-model="otp_number" /></v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="2"></v-col>

                    <v-col cols="12" md="2"></v-col>
                    <v-col cols="12" md="8">
                        <v-row>
                            <v-col cols="12" md="3" sm="12">{{ lang.ar_company_name}}</v-col>
                            <v-col cols="12" md="3" sm="12"><b-form-input class="inborder" v-model="zatca.company_name_ar" /></v-col>

                            <v-col cols="12" md="3" sm="12">{{ lang.en_company_name}}</v-col>
                            <v-col cols="12" md="3" sm="12"><b-form-input class="inborder" v-model="zatca.company_name_en" /></v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="2"></v-col>

                    <v-col cols="12" md="2"></v-col>
                    <v-col cols="12" md="8">
                        <v-row>
                            <v-col cols="12" md="3" sm="12">{{ lang.vat_number}}</v-col>
                            <v-col cols="12" md="3" sm="12"><b-form-input class="inborder" v-model="zatca.vat_number" /></v-col>

                            <v-col cols="12" md="3" sm="12">{{ lang.crt_number}}</v-col>
                            <v-col cols="12" md="3" sm="12"><b-form-input class="inborder" v-model="zatca.crt_number" /></v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="2"></v-col>

                    <v-col cols="12" md="2" sm="12"></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.en_address}}</v-col>
                    <v-col cols="12" md="6" sm="12"><b-form-input class="inborder" v-model="zatca.address_en" /></v-col>
                    <v-col cols="12" md="2" sm="12"></v-col>
                    <v-col cols="12" md="2" sm="12"></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.ar_address}}</v-col>
                    <v-col cols="12" md="6" sm="12"><b-form-input class="inborder" v-model="zatca.address_ar" /></v-col>
                    <v-col cols="12" md="2" sm="12"></v-col>



                    <v-col cols="12" md="2" sm="12"></v-col>
                    <v-col cols="12" md="8" sm="12" class="text-center backRed">
                        {{ lang.national_address }}
                    </v-col>
                    <v-col cols="12" md="2" sm="12"></v-col>

                    <v-col cols="12" md="2" sm="12"></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.country_code}}</v-col>
                    <v-col cols="12" md="2" sm="12"><b-form-input class="inborder" v-model="zatca.country_code" /></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.building_no}}</v-col>
                    <v-col cols="12" md="2" sm="12"><b-form-input class="inborder" v-model="zatca.building_no" /></v-col>
                    <v-col cols="12" md="2" sm="12"></v-col>

                    <v-col cols="12" md="2" sm="12"></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.branch_number}}</v-col>
                    <v-col cols="12" md="2" sm="12"><b-form-input class="inborder" v-model="zatca.branch_number" /></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.zipcode}}</v-col>
                    <v-col cols="12" md="2" sm="12"><b-form-input class="inborder" v-model="zatca.zipcode" /></v-col>
                    <v-col cols="12" md="2" sm="12"></v-col>

                    <v-col cols="12" md="2" sm="12"></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.street_name_ar}}</v-col>
                    <v-col cols="12" md="2" sm="12"><b-form-input class="inborder" v-model="zatca.street_name_ar" /></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.street_name_en}}</v-col>
                    <v-col cols="12" md="2" sm="12"><b-form-input class="inborder" v-model="zatca.street_name_en" /></v-col>
                    <v-col cols="12" md="2" sm="12"></v-col>

                    <v-col cols="12" md="2" sm="12"></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.district_ar}}</v-col>
                    <v-col cols="12" md="2" sm="12"><b-form-input class="inborder" v-model="zatca.district_ar" /></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.district_en}}</v-col>
                    <v-col cols="12" md="2" sm="12"><b-form-input class="inborder" v-model="zatca.district_en" /></v-col>
                    <v-col cols="12" md="2" sm="12"></v-col>

                    <v-col cols="12" md="2" sm="12"></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.city_ar}}</v-col>
                    <v-col cols="12" md="2" sm="12"><b-form-input class="inborder" v-model="zatca.city_ar" /></v-col>
                    <v-col cols="12" md="2" sm="12">{{ lang.city_en}}</v-col>
                    <v-col cols="12" md="2" sm="12"><b-form-input class="inborder" v-model="zatca.city_en" /></v-col>
                    <v-col cols="12" md="2" sm="12"></v-col>

                    <v-col cols="12">
                        <small style="color:red">{{ lang.opt_number_description }}</small>
                    </v-col>
                </v-row>

            </v-col>

            <v-col cols="12" md="2" sm="12"></v-col>
            <v-col cols="12" md="8" sm="12" class="text-end" style="padding:5px">
                <v-btn style="background:green;color:#FFF;margin-bottom:30px;" @click="didUpdate ()">{{lang.save}}</v-btn>
            </v-col>
            <v-col cols="12" md="2" sm="12"></v-col>
        </v-row>
        <div>

        </div>



        <vue-snotify></vue-snotify>
    </div>
        <Footer />
    </div>
</template>

<script>
import axios from 'axios'
import BreadCrumbs from '@/components/breadCrumbs.vue';
import TabsComp from '@/components/tabsComp.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import {SnotifyPosition} from 'vue-snotify';
export default{
    components: {BreadCrumbs, TabsComp, HeaderPortrate, Footer},
    data() {
        return {
            currentFile: undefined,
            progress: 0,
            active_tab:0,
            message: "",
            otp_number: '',
            zatca: {
                company_name_ar: '',
                company_name_en: '',
                vat_number: '',
                crt_number: '',
                zatca_type: 1,
                address_ar: '',
                address_en: '',
                active_zatca: 1,
                building_no: '',
                street_name_ar: '',
                street_name_en: '',
                branch_number: '',
                district_ar: '',
                district_en: '',
                country_code: 'SA',
                city_ar: '',
                city_en: '',
                zipcode: '',
            }
        }
    },
    methods: {

        getSettings()
        {
            const post = new FormData();
            post.append("type",'getZatcaSettings');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$COOKIEPhase));
            post.append("data[all]",'all');
            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then(
                (response) => {
                    this.otp_number = '';
                    const res = response.data;
                    this.zatca = res.results.data;
                }
            )
        },
        didUpdate()
        {
            let doIt = true;
            let message = this.lang.all_fields_required;
            const regex = /^[A-Za-z0-9 ]+$/;
            const isNumberOnly = (value) => /^[0-9]+$/.test(value);


            // alert(this.zatca.vat_number.toString()[0])
            Object.keys(this.zatca).forEach(key => {
                if(this.zatca[key] == '') {
                    // alert("error: " + key);
                    doIt = false;
                    return true;
                }
                else if(
                        key == 'vat_number' && (
                            !isNumberOnly(this.zatca.vat_number) ||
                            (this.zatca.vat_number.toString().length != 10 && this.zatca.vat_number.toString().length != 15)
                        )
                ){
                    message = this.lang.vat_number_required;
                    doIt = false;
                    return true;
                }
                else if (
                    key == "vat_number" &&
                    (
                        this.zatca.vat_number.toString()[0] != 3 ||
                        (
                            this.zatca.vat_number.toString()[14] != 3 && this.zatca.vat_number.toString().length == 15
                        )
                    )
                ){
                    if(this.zatca.vat_number.toString()[0] != 3){
                        message = this.lang.vat_number_start_with_3;
                    }else{
                        message = this.lang.vat_number_end_with_3
                    }

                    doIt = false;
                    return true;
                }
                else if(
                        key == 'crt_number'  && (
                            !isNumberOnly(this.zatca.branch_number) || this.zatca.branch_number.toString().length != 4
                        )
                ) {
                    message = this.lang.branch_number_requirs;
                    doIt = false;
                    return true;
                }
                else if(
                        key == 'crt_number'  && (
                            !isNumberOnly(this.zatca.crt_number) || this.zatca.crt_number.toString().length != 10
                        )
                ) {
                    message = this.lang.crt_number_requirs;
                    doIt = false;
                    return true;
                }
                else if(
                        key == 'building_no'  && (
                            !isNumberOnly(this.zatca.building_no) || this.zatca.building_no.toString().length != 4
                        )
                ) {
                    message = this.lang.building_no_requirs;
                    doIt = false;
                    return true;
                }
                else if(
                        key == 'zipcode'  && (
                            !isNumberOnly(this.zatca.zipcode) || this.zatca.zipcode.toString().length != 5
                        )
                ) {
                    message = this.lang.zipcode_requirs;
                    doIt = false;
                    return true;
                }
                else if(
                        key == 'address_ar'  && this.zatca.address_ar.toString().length > 100
                ) {
                    message = this.lang.address_ar_requirs;
                    doIt = false;
                    return true;
                }
                else if(
                        key == 'address_en'  && (this.zatca.address_en.toString().length > 100 || !regex.test(this.zatca.address_en))
                ) {
                    message = this.lang.address_en_requirs;
                    doIt = false;
                    return true;
                }
                else if(
                        key == 'compnay_name_en'  && !regex.test(this.zatca.compnay_name_en)
                ) {
                    message = this.lang.compnay_name_en_requirs;
                    doIt = false;
                    return true;
                }
            })
            if(doIt){
                if(this.zatca.active_zatca == 2){
                    if(this.otp_number == ''){
                        message = this.lang.otp_number_required;
                        doIt = false;
                    }else if(this.otp_number.toString().length != 6){
                        message = this.lang.otp_number_required;
                        doIt = false;
                    }
                }
            }
            if(!doIt){
                this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.close,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                            }
                        },
                    ]
                });
                return false;
            }
            if(this.zatca.active_zatca == 1){
                message = this.lang.you_will_save_information_without_any_creating_action;
            }else if (this.active_zatca == 2){
                if(this.zatca.zatca_type == 1){
                    message = this.lang.you_will_create_private_and_public_keys_only;
                }
                else if(this.zatca.zatca_type == 2){
                    message = this.lang.you_will_create_simultation_certificat;
                }
                else if(this.zatca.zatca_type == 3){
                    message = this.lang.you_will_create_production_certificat;
                }
            }
            this.$snotify.error(message, this.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.cancel,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                    {
                        text: this.lang.continue,
                        action: (toast) => {
                            this.updateSettings();
                            this.$snotify.remove(toast.id);
                        }
                    },
                ]
            });
            return false;
        },
        containsArabic(text) {
            // Arabic Unicode range: \u0600-\u06FF
            const arabicRegex = /[\u0600-\u06FF]/;
            return !arabicRegex.test(text);
        },
        updateSettings(){
            // console.log(this.settings.logo_img)
            const post = new FormData();
            post.append("type",'updateZatcaSettings');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth",this.$cookies.get(this.$COOKIEPhase));
            const zatca = {
                company_name: this.zatca.company_name_ar,
                company_name_en: this.zatca.company_name_en,
                vat_number: this.zatca.vat_number,
                crt_number: this.zatca.crt_number,
                zatca_type: this.zatca.zatca_type,
                address: this.zatca.address_ar,
                address_en: this.zatca.address_en,
                active_zatca: this.zatca.active_zatca,
                BuildingNumber: this.zatca.building_no,
                street: this.zatca.street_name_ar,
                street_en: this.zatca.street_name_en,
                branch_number: this.zatca.branch_number,
                district: this.zatca.district_ar,
                district_en: this.zatca.district_en,
                country_code: this.zatca.country_code,
                city: this.zatca.city_ar,
                city_en: this.zatca.city_en,
                zipcode: this.zatca.zipcode,
            }
            post.append("data[zatca]",JSON.stringify(zatca));
            post.append("data[otp_number]",this.otp_number);

            axios.post(
                this.$SAMCOTEC.r_path,post
            ).then(
                (response) => {
                    this.getSettings();
                    const res = response.data;
                    let message = this.lang.updated_successfully_zatca
                    this.$snotify.error(message, this.lang.alert, {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                        buttons: [
                            {
                                text: this.lang.close,
                                action: (toast) => {
                                    this.$snotify.remove(toast.id);
                                }
                            },
                        ]
                    });
                    return false;
                }
            )
        }
    },

    created() {
        this.getSettings();
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        zatca_type: function()
        {
            return [
                {text: this.lang.zatca_create_cert_only, value: 1},
                {text: this.lang.zatca_sandbox_integration, value: 2},
                {text: this.lang.zatca_production_integration, value: 3},
            ]
        },
        active_zatca: function()
        {
            return [
                {text: this.lang.zatca_not_active, value: 1},
                {text: this.lang.zatca_enable_integration, value: 2},
            ]
        },
        display_message: function() {
            if(this.zatca.active_zatca == 1) return this.lang.zatca_not_integrated_message;
            if(this.zatca.active_zatca == 2) return this.lang.zatca_integrated_message;
            else return this.lang.zatca_not_integrated_message
        },
        items: function() {
            return {
                    text: this.lang.system_settings,
                    disabled: true,
                    to: '/settings/system-settings',
                }
        },
        tabs: function() {
            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }

            })

            return t;
        }
    },
}
</script>